import px_img01 from '../images/px-img-08.png'
import { Icon } from '@iconify/react'
import { Helmet } from 'react-helmet';
import Cta from '../component/Cta';
import Client from '../component/Client';
import MainTestimonial from "../component/slider/MainTestimonial";
import Blog from '../component/Blog';
import {NavLink } from "react-router-dom";
import ContactForm from '../component/forms/ContactForm';
import email from '../images/icon/email.png'
export default function ContactUs() {
    
    return (
        <div>
            <Helmet>
                <title>ParcelX - Contact Us</title>
            </Helmet>
            <section className='section01'>
                <div className='container-fluid'>
                    <div className='black-img-bg'>
                        <div className='row'>
                            <div className='col-md-6 order-md-2  d-md-block d-none'>
                                <img src={px_img01} className='img-fluid rounded-5' />
                            </div>
                            <div className='col-md-6 contact-us'>
                                <h2 className='heading-title text-white'>Contact us</h2>
                                <p className='text-white'>Whether you need more information or have specific concerns, our team is ready to provide detailed answers. Get the clarity you need with personalized support and expert guidance </p>
                                <ContactForm />
                                <p className='contacting-policy text-center'>By Contacting us, you agree to our <NavLink to="/terms">Terms</NavLink> of service and <NavLink to="/privacy">privacy Policy</NavLink></p>
                                <p className='text-center text-white'>© 2026 ParcelX, All right reserved</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='contact primary-bg'>
                <div className='container-fluid'>
                    <div className='col-md-12 mx-auto'>
                        <div className='row align-items-end'>
                            <div className='col-md-6'>
                                <div className='contact-badge'>Still facing issues?</div>
                                <h2 className='sub-heading f-32 text-white'>Drop us a line. We reply fast.</h2>
                                <p className='text-white'>Not sure where to start? Just email us — our team reviews every message and gets back to you with the right answer, usually within a few hours.</p>
                            </div>
                            <div className='col-md-6'>
                                <div className='contact-question-box'>
                                    {/* <div className='question-item'>
                                        <Icon icon='la:phone-volume' />
                                        <a href='tel:9311936818' className='text-white'>+91 9311936818</a>
                                        <p>We Are Always Ready to Help</p>
                                    </div> */}
                                    <div className='contact-question-item'>
                                        <a href="mailto:hello@parcelx.in" className='text-white' target="_blank" rel="noopener noreferrer">
                                            {/* <Icon icon='line-md:email-opened' /> */}
                                            <img src={email} />
                                            <div>
                                                <p>Email us at</p>
                                                <p>hello@parcelx.in</p>
                                            </div>
                                        </a>
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Client/>
            <MainTestimonial />
            {/* <section className='section02 pb-0'>
                <div className='container-fluid'>
                    <div className='col-md-11 mx-auto'>
                        <div className='row'>
                            <div className='col-md-6'>
                                <h2 className='heading'><span>Get in touch</span> with us. We're here to assist you.</h2>
                                <ul className='social justify-content-start mb-0'>
                                    <NavLink to={'https://x.com/Parcelx_in'} target='_blank'>
                                        <li className='social-media'>
                                            <i className="fab fa-twitter"></i>
                                        </li>
                                    </NavLink>
                                    <NavLink to={'https://www.facebook.com/p/Parcel-X-100065408592406/'} target='_blank'>
                                        <li className='social-media'>
                                            <i className="fab fa-facebook-f"></i>
                                        </li>
                                    </NavLink>
                                    <NavLink to={'https://www.instagram.com/parcelx.in'} target='_blank'>
                                        <li className='social-media'>
                                            <i className="fab fa-instagram"></i>    
                                        </li>
                                    </NavLink>
                                    <NavLink to={'https://in.linkedin.com/company/parcel-x'} target='_blank'>
                                        <li className='social-media'>
                                            <i className="fab fa-linkedin"></i>
                                        </li>
                                    </NavLink>
                                    <NavLink to={'https://www.youtube.com/@ParcelX'} target='_blank'>
                                        <li className='social-media'>
                                            <i className="fab fa-youtube"></i>
                                        </li>
                                    </NavLink>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            {/* <Blog /> */}
            <Cta />
        </div>
    )
} 
